import * as React from "react";
import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./components/AuthContext";
import { AppProvider } from "./components/AppContext";
import { TranslationProvider } from "./i18n/TranslationContext";
import { router } from "./router/RouterConfig";

export default function App() {
	// Clean up old language preference from localStorage
	useEffect(() => {
		localStorage.removeItem("preferredLanguage");
	}, []);

	return (
		<React.StrictMode>
			<TranslationProvider>
				<SnackbarProvider
					maxSnack={3}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					autoHideDuration={4000}
				>
					<AppProvider>
						<AuthProvider>
							<RouterProvider router={router} />
						</AuthProvider>
					</AppProvider>
				</SnackbarProvider>
			</TranslationProvider>
		</React.StrictMode>
	);
}
